<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>

    <el-dialog title="PDF列表" :visible.sync="dialogMultPdf" width="30%">
      <div class="mainPDF" :key="index" v-for="(item, index) in dialogPdfArr">
        <label>{{ item.sign_name }}</label>
        <img
          @click="goPage(item)"
          style="width: 60px; height: auto; cursor: pointer"
          src="https://xl-online.oss-cn-hangzhou.aliyuncs.com/xladmin/static/icon_pdf.png"
        />
      </div>
    </el-dialog>

    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <div class="table-header-gai">
            <el-button
              v-if="userPermissions.indexOf('customer_sign') != -1"
              size="medium"
              type="primary"
              class="cusomer-link-gai"
              @click="cusomerLink"
              icon="el-icon-paperclip"
              >发布任务
            </el-button>
            <el-button
              v-if="showLinkBtn"
              size="medium"
              type="primary"
              class="cusomer-link-search"
              @click="showQyLink"
            >
              查询签约链接
            </el-button>
            <GetSMSLinkList v-if="userPermissions.indexOf('privateTask_link') != -1" ref="SMSLinkList"></GetSMSLinkList>
        </div>
        <el-row style="height: 36px">
          <el-form size="medium" :inline="true" :model="searchCondition">
            <el-form-item label="任务名称">
              <el-input
                v-model="searchCondition.title"
                placeholder="输入任务名称"
                class="item-name"
                clearable
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="行业类型">
              <el-cascader
                v-model="searchCondition.recruit_type_id"
                placeholder="请选择行业类型"
                clearable
                filterable
                :options="formList[1].selectOption"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="任务类型">
              <el-select
                v-model="searchCondition.category_id"
                filterable
                clearable
                :multiple-limit="1"
                placeholder="请选择任务类型"
                class="selectWord"
              >
                <el-option
                  v-for="item in categoryList"
                  :label="item.name"
                  :key="item.id"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
            <div class="table-right">
              <!-- <el-form-item>
                <el-button
                  :loading="sign_downloadLoading"
                  type="primary"
                  icon="el-icon-document"
                  @click="handleDownload_sign"
                >
                  批量下载协议
                </el-button>
              </el-form-item> -->
              <el-form-item>
                <el-select
                  v-model="exportSelect"
                  @change="changeExportOption"
                  class="select-box"
                >
                  <el-option
                    v-for="item in exportOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button
                  :loading="downloadLoading"
                  type="primary"
                  icon="el-icon-document"
                  @click="handleDownload"
                >
                  导出
                </el-button>
              </el-form-item>
            </div>
          </el-form>
        </el-row>

        <!-- 生成签约链接的dialog模态框 -->
        <el-dialog
          title="查询签约链接"
          :visible.sync="showQyLinkVisible"
          width="40%"
        >
          <el-form>
            <el-form-item label="手机号">
              <el-input
                v-model="qyLinkForm.mobile"
                maxlength="11"
                placeholder="请输入手机号"
                class="item-mobile"
                clearable
              ></el-input>
              <el-button
                class="searchBtnQYLink"
                type="primary"
                @click="event_searchLink"
                >查询</el-button
              >
            </el-form-item>
            <el-form-item label="签约链接">
              <div class="qyLinkArea">
                <div class="linkurl" v-if="qyLinkForm.url">
                  {{ qyLinkForm.url }}
                </div>
                <div v-else class="linkurl-nodata">暂无签约链接</div>
                <el-button
                  v-if="qyLinkForm.url"
                  class="searchBtnQYLink"
                  type="text"
                  @click="copyLink"
                  >复制链接</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </el-dialog>

        <!-- 生成签约链接的dialog模态框 -->
        <el-dialog
          class="create-task"
          title="生成合作邀请码"
          :visible.sync="outerVisible"
          :before-close="handleOuterClose"
          width="55%"
        >
          <div class="quick-create-btn">
            <el-popover
              placement="right"
              width="200"
              trigger="click">
                <el-select
                  v-model="job_id"
                  filterable
                  clearable
                  placeholder="请选择关联岗位"
                  @change="selectJob"
                >
                  <el-option
                    v-for="item in jobList"
                    :label="item.recruit_post"
                    :key="item.id"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              <el-button slot="reference"
                @click="quickCreate"
                  type="primary"
                  size="mini"
                  >快速创建
                </el-button>
            </el-popover>
            
          </div>
          <el-form ref="refForm" size="mini" :inline="true" label-width="100px" :model="companyFormData">
            <!-- <el-col v-if="is_quick" :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :span="12">
              <el-form-item label="关联岗位">
                <el-select
                  v-model="job_id"
                  filterable
                  clearable
                  placeholder="请选择关联岗位"
                  @change="selectJob"
                >
                  <el-option
                    v-for="item in jobList"
                    :label="item.recruit_post"
                    :key="item.id"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :span="12" v-for="(item, index) in formList"
                :key="index">
              <el-form-item
                size="mini"
                :label="item.label"
                :prop="item.props"
                :required="item.required"
                :show-message="false"
                :rules="[
                  {
                    required: item.required,
                    message: '请输入' + item.label,
                    trigger: 'blur',
                  },
                ]"
              >
                <template v-if="item.type == 'input'">
                  <el-input
                    v-model="companyFormData[item.props]"
                    :placeholder="item.placeholder"
                  ></el-input>
                </template>
                <template v-else-if="item.type == 'textarea'">
                  <el-input
                    type="textarea"
                    v-model="companyFormData[item.props]"
                  ></el-input>
                </template>
                <template v-else-if="item.type == 'picker'">
                  <el-select
                    v-model="companyFormData[item.props]"
                    placeholder="请选择"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="(item1, index1) in item.selectOption"
                      :key="index1"
                      :label="item1.label"
                      :value="item1.value"
                    ></el-option>
                  </el-select>
                </template>
                <template v-else-if="item.type == 'multiplePicker'">
                  <el-select
                    v-model="companyFormData[item.props]"
                    placeholder="请选择"
                    clearable
                    filterable
                    multiple
                  >
                    <el-option
                      v-for="(item1, index1) in item.selectOption"
                      :key="index1"
                      :label="item1.label"
                      :value="item1.value"
                    ></el-option>
                  </el-select>
                </template>
                <template v-else-if="item.type == 'cascader'">
                  <el-cascader
                    v-model="companyFormData[item.props]"
                    placeholder="请选择"
                    clearable
                    filterable
                    :options="item.selectOption"
                  >
                  </el-cascader>
                </template>
                <template v-else-if="item.type == 'salary'">
                  <div style="width: 240px;">
                    <el-col :span="10">
                    <el-input
                      class="salary-input"
                      v-model="companyFormData.min_salary"
                      placeholder="最低薪资"
                    />
                    </el-col>
                    <el-col :span="2" class="text-center">
                      <span class="text-gray-500">-</span>
                    </el-col>
                    <el-col :span="10">
                      <el-input
                        class="salary-input"
                        v-model="companyFormData.max_salary"
                        placeholder="最高薪资"
                      />
                    </el-col>
                    <el-col :span="2">
                      <el-tooltip class="item" effect="dark" content="如若填写相同薪资，则展示固定薪资" placement="right">
                        <i class="el-icon-warning"></i>
                      </el-tooltip>
                    </el-col>
                  </div>
                  
                </template>
              </el-form-item>
            </el-col>
            
            <el-form-item :show-message="false" required label-width="120px" label="请选择任务类型" prop="name" id="desc">
              <el-checkbox-group
                v-model="companyFormData.name"
                size="small"
                @change="handleTaskChange"
                :max="10"
              >
                <el-checkbox
                  v-for="item in categoryList"
                  :label="item.name"
                  :key="item.id"
                  border
                >
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <div style="margin-bottom: 10px;">
              <div class="task-description-label" style="margin-bottom: 6px;">
                任务描述
              </div>
              <el-input
                type="textarea"
                rows="6"
                placeholder="请输入任务描述"
                maxlength="200"
                show-word-limit
                v-model="companyFormData.missionContent"
              >
              </el-input>
            </div>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :span="12" v-for="(item, index) in formList2"
                :key="index">
              <el-form-item
                label-width="80px"
                size="mini"
                :label="item.label"
                :prop="item.props"
                :required="item.required"
                :show-message="false"
                :rules="[
                  {
                    required: item.required,
                    message: '请输入' + item.label,
                    trigger: 'blur',
                  },
                ]">
                <template v-if="item.type == 'picker'">
                  <el-select
                    v-model="companyFormData[item.props]"
                    placeholder="请选择"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="(item1, index1) in item.selectOption"
                      :key="index1"
                      :label="item1.label"
                      :value="item1.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
          </el-form>

          <el-dialog
            width="40%"
            :title="'系统提示'"
            :close-on-click-modal="false"
            :visible.sync="innerVisible"
            :before-close="handleInnerClose"
            append-to-body
          >
            <div v-if="dialogType == 1">
              <div class="dialog-title">
                <i
                  class="el-icon-success"
                  style="font-size: 40px; color: #409eff"
                ></i>
                <span class="title-text">手机扫一扫，请到手机端分享</span>
              </div>
              <div class="center-box">
                <div class="code">
                  <img
                    :src="this.OrImage"
                    class="QR-code"
                    v-if="this.OrImage"
                  />
                  <div class="tips">
                    打开微信[扫一扫]
                  </div>
                </div>
                <div
                  class="alipay-code code"
                  v-if="this.noaliqrcodeUrl.includes(this.host) == false"
                >
                  <img
                    :src="this.alipayOrImage"
                    class="QR-code"
                    v-if="this.alipayOrImage"
                  />
                  <div class="tips">
                    打开支付宝[扫一扫]
                  </div>
                </div>
				
              </div>
            </div>
            <div v-if="dialogType == 2">
              <div class="center-box">
                {{ tabContent }}
              </div>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button
                type="primary"
                @click="closeQRDialog"
                size="medium"
                :disabled="isCheck"
                >关闭
              </el-button>
            </div>
          </el-dialog>
          <div
            slot="footer"
            class="dialog-footer"
            style="text-align: center; margin-bottom: 20px"
          >
            <!-- <el-button @click="outerClose" size="medium">取 消</el-button> -->
            <el-button
              type="primary"
              @click="checkCategory"
              size="medium"
              :disabled="isCheck"
              >生成合作邀请码
            </el-button>
          </div>
        </el-dialog>

        <el-dialog
			width="40%"
			:title="'系统提示'"
			:close-on-click-modal="false"
			:visible.sync="qrVisible"
			:before-close="handleQRClose"
			append-to-body
		>
			<div v-if="tabType==1">
				<div class="dialog-title">
					<i
						class="el-icon-success"
						style="font-size: 40px; color: #409eff"
					></i>
					<span class="title-text">手机扫一扫，请到手机端分享</span>
				</div>
				<div class="center-box code-text-box">
          <div class="center-box">
            <div class="code">
              <img
                :src="this.OrImage"
                class="QR-code"
                v-if="this.OrImage"
              />
              <div class="tips">
                打开微信[扫一扫]
              </div>
            </div>
            <div
              class="alipay-code code"
              v-if="this.noaliqrcodeUrl.includes(this.host) == false"
            >
              <img
                :src="this.alipayOrImage"
                class="QR-code"
                v-if="this.alipayOrImage"
              />
              <div class="tips">
                打开支付宝[扫一扫]
              </div>
            </div>
    
          </div>
					<!-- <div class="code-text-con" v-if="sys_data.wx_url_link">
					<div class="code-text">{{sys_data.wx_url_link}}</div>
					<el-button
					
					class="searchBtnQYLink"
					type="text"
					@click="copyText(sys_data.wx_url_link)"
					>复制链接</el-button
					>
					</div> -->
				</div>
			</div>
			<div v-if="tabType==2">
				<div class="center-box">
					<el-input type="textarea" readonly rows="8" :value="tabContent"></el-input>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button
					type="primary"
					@click="handleQRClose"
					size="medium">
				关闭
				</el-button>
			</div>
		</el-dialog>

        <el-dialog
          width="40%"
          :title="'系统提示'"
          :close-on-click-modal="true"
          :visible.sync="qzFlag"
          append-to-body
        >
          <div class="dialog-title">
            <i
              class="el-icon-success"
              style="font-size: 40px; color: #409eff"
            ></i>
            <span class="title-text">请用户再次核对手写签章</span>
          </div>
          <div class="center-box">
            <img
              :src="this.OrImage_qz"
              class="QR-code"
              v-if="this.OrImage_qz"
            />
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="qzFlag = false" size="medium"
              >关闭
            </el-button>
          </div>
        </el-dialog>

        <ApeTable
          ref="apeTable"
          :data="companyList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column align="center" label="薪资水平">
            <template slot-scope="scope">
              <div>{{ getSalaryType(scope.row) }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="任务发布时间">
            <template slot-scope="scope">
              <div>{{ scope.row.created_at }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="审核状态">
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.examine_status == "1"
                    ? "审核成功"
                    : scope.row.examine_status == "2"
                    ? "审核失败"
                    : "审核中"
                }}
              </div>
              <div
                style="color:#1890ff;cursor: pointer;"
                v-if="scope.row.examine_status == '2'"
                @click="showMissionContent(scope.row.examine_reason)"
              >
                查看失败原因
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态">
            <template slot-scope="scope">
              <div>{{ scope.row.status | TransactionStatus }}</div>
            </template>
          </el-table-column>

          <el-table-column align="center" label="报名审核">
            <template slot-scope="scope">
              <div
                style="color:#1890ff;cursor: pointer;"
                v-if="
                  scope.row.examine_status == '1'"
                  @click="toPersonnellistExamine(scope.row)">
                查看
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>

          <el-table-column align="center" label="合作邀请码">
            <template slot-scope="scope">
              <div
                style="color:#1890ff;cursor: pointer;"
                v-if="
                  scope.row.examine_status == '1' &&
                    scope.row.status == '1' &&
                    scope.row.code_url
                "
                @click="showMissionCode(scope.row.code_url,scope.row)"
              >
                查看
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="buttonType == 'text'"
            width="160"
            header_align="center"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <span>
                <el-button
                  type="infor"
                  size="mini"
                  @click="toCustomer(scope.row)"
                  >查看</el-button
                >
                <el-popover
                  placement="top"
                  v-model="scope.row.visible"
                  v-if="scope.row.examine_status == '1'"
                >
                  <p>确定要修改状态吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button
                      type="text"
                      size="mini"
                      @click="scope.row.visible = false"
                      >取消</el-button
                    >
                    <el-button
                      type="danger"
                      size="mini"
                      @click="checkUpload(scope.row.status, scope.row.id)"
                      >确定</el-button
                    >
                  </div>
                  <el-button
                    size="mini"
                    :type="scope.row.status == 1 ? 'danger' : 'primary'"
                    slot="reference"
                    >{{ scope.row.status == 1 ? "关闭" : "开启" }}</el-button
                  >
                </el-popover>
                <el-button type="infor" size="mini" @click="toView(scope.row)"
                  >详情</el-button
                >
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
      <div class="people-btn-wrapper" v-if="this.is_import == 1">
        <el-button
          v-if="userPermissions.indexOf('customer_import') != -1"
          style="color: #1890ff"
          size="medium"
          @click="importExcel"
          icon="iconfont el-icon-upload"
          >人才Excel导入
        </el-button>
        <el-button
          type="text"
          size="medium"
          @click="
            mxGoUrl(
              mxGetOssUrl(
                '/sample/excel/%E4%BA%BA%E6%89%8D%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
                true
              )
            )
          "
        >
          人才导入模板.xlsx
        </el-button>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import DatePicker from "@/components/DatePicker.vue";
import json from "../../../public/citys.json";
import { gettreeList, getSalaryTypeText,SALARY_TYPE_LIST,TOG_SALARY_TYPE_VALUE_MAP } from "@/utils/utils";
import GetSMSLinkList from "./components/getSMSLinkList.vue";
//import signCompent from "./sign.vue";
import { mapGetters, mapState } from "vuex";
import store from "@/store";
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker,
    GetSMSLinkList
    //signCompent
  },
  data() {
    return {
      is_quick:false,
      job_id:'',
      jobList:[],
      tabType:1,
      json,
      qrVisible:false,
      host: window.location.host,
      noaliqrcodeUrl: ["khlztrz.51xinlong.com", "www.ztrztd.com"],
      showLinkBtn: false,
      qyLinkForm: {
        mobile: "",
        url: "",
      },
      is_E_sign: false,
      sign_downloadLoading: false,
      showDesc: false,
      is_show_djg: "",
      dialogPdfArr: [],
      dialogMultPdf: false,
      OrImage_qz: "",
      qzFlag: false,
      checkList: ["选中且禁用", "复选框 A"],
      //选择签约类型
      hidenumber: "****",
      value: "",
      companyFormData: {
        category_id: [],
        name: [],
        missionContent: "",
        mission_type:1,
        renew_type: 1,
      },
      categoryList: [],
      signUrl: "", //签约链接
      showQyLinkVisible: false,
      outerVisible: false, //外层模态框状态
      innerVisible: false, //内层模态框状态
      searchCategory: [],
      // 搜索条件
      searchCondition: {},
      loadingStaus: true,
      // 表单验证
      formRules: {
        title: [
          {required: true, message: '请输入任务名称', trigger: 'blur' },
        ],
        // unique_identify: [
        //   {required: true, message: '选择类型', trigger: 'blur' },
        // ],
        is_show: [
          {required: true, message: '选择状态', trigger: 'blur' },
        ],
        image: [
          {required: true, message: '上传图片', trigger: 'blur', validator:this.apeUploaderVerify},
        ],
      },
      formList: [
        {
          required: true,
          label: "任务名称",
          type: "input",
          props: "title",
          value: "",
          placeholder: "请输入任务名称",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "行业类型",
          type: "cascader",
          props: "recruit_type_id",
          value: [],
          selectOption: [],
          placeholder: "请选择行业类型",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "工作地点",
          type: "cascader",
          props: "work_city",
          value_text_props: "address",
          value: "",
          selectOption: json.data,
          valueLevel: "more",
          placeholder: "请选择工作地点",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "详细地点",
          type: "input",
          props: "address",
          placeholder: "请输入详细地点",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "结算方式",
          type: "picker",
          props: "salary_type",
          selectOption: SALARY_TYPE_LIST,
          placeholder: "请选择结算方式",

          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "用工人数",
          type: "input",
          props: "person_num",
          value: "",
          placeholder: "请输入用工人数",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "薪资范围",
          type: "salary",
          props: "min_salary",
          placeholder: "请输入薪资",
          value: "",
          show: true,
        },
        // {
        //   required: true,
        //   id: "min_salary",
        //   label: "最低薪资",
        //   type: "input",
        //   props: "min_salary",
        //   placeholder: "请输入最低薪资",
        //   value: "",
        //   show: true,
        // },
        // {
        //   required: true,
        //   label: "最高薪资",
        //   type: "input",
        //   props: "max_salary",
        //   placeholder: "请输入最高薪资",
        //   value: "",
        //   show: true,
        // },
        {
          required: true,
          label: "学历要求",
          type: "picker",
          props: "min_qualification",
          selectOption: [
            { label: "不限", value: "0" },
            { label: "小学", value: "1" },
            { label: "初中", value: "2" },
            { label: "高中", value: "3" },
            { label: "大专", value: "4" },
            { label: "本科及以上", value: "5" },
          ],
          placeholder: "请选择学历要求",
          value: "",
          disabled: false,
          show: true,
        },
        
        // {
        //   label: "任务描述",
        //   type: "textarea",
        //   props: "missionContent",
        //   value: "",
        //   placeholder: "请输入任务描述",
        //   disabled: false,
        //   show: true,
        // },
      ],
      formList2:[{
          required: true,
          label: "任务属性",
          type: "picker",
          props: "mission_type",
          selectOption: [
            { label: "非公开", value: 1 },
            { label: "公开", value: 2 },
          ],
          placeholder: "请选择任务属性",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: false,
          label: "岗位时效",
          type: "picker",
          props: "renew_type",
          selectOption: [
            { label: "1个月", value: 1 },
            { label: "2个月", value: 2 },
            { label: "3个月", value: 3 },
          ],
          placeholder: "请选择岗位时效",
          value: 1,
          disabled: false,
          show: true,
        }],
      columns: [
        {
          title: "任务编号",
          value: "id",
          width: 170,
          header_align: "center",
          align: "center",
        },
        {
          title: "任务名称",
          value: "title",
          header_align: "center",
          align: "center",
        },     
        {
          title: "任务类型",
          value: "category_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "行业类型",
          value: "recruit_type_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "工作地点",
          value: "all_address",
          header_align: "center",
          align: "center",
        },
      ],
      // 表格列表数据
      companyList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      // 分页的offset,序号列使用
      offset: 0,
      // 已上传文件列表
      uploadFileList: [],
      // 表单验证
      rules: {
        title: [{ required: true, message: "输入标题", trigger: "blur" }],
        type: [{ required: true, message: "选择类型", trigger: "blur" }],
        is_new_win: [
          { required: true, message: "选择打开发方式", trigger: "blur" },
        ],
        is_show: [{ required: true, message: "选择状态", trigger: "blur" }],
        image: [
          {
            required: true,
            message: "上传图片",
            trigger: "blur",
            validator: this.apeUploaderVerify,
          },
        ],
      },
      // 抽屉数据，附件列表
      drawerData: {
        visible: false,
        loading: true,
        loading_text: "正在加载中……",
        // direction: 'right',
        title: "",
        width_height: "640px",
        show_footer: false,
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      // 附件列表
      attachmentList: [],
      // 附件列表字段定义
      attachmentColumns: [
        {
          title: "标题",
          value: "title",
        },
      ],
      // 添加附件
      dialogData: {
        visible: false,
        title: "",
        width: "24%",
        loading: true,
        modal: false,
      },
      // 附件表单内容
      formData: {},
      // 附件添加表单验证
      dialogRules: {
        title: [{ required: true, message: "输入标题", trigger: "blur" }],
      },
      // 附件类型
      attachmentType: [
        "application/pdf",
        "application/caj",
        "",
        "application/zip",
        "application/rar",
        "application/doc",
      ],
      // 已上传附件列表
      attachmentUploadFileList: [],
      // 当前需要操作附件的文章id
      currentCompanyId: 0,
      isCheck: true, //是否禁用确定按钮
      category_Id: "",
      category_name: "",
      id: "",
      OrImage: "",
      alipayOrImage: "",
      is_import: "",
      exportOptions: [
        {
          value: "xlsx",
          label: "xlsx",
        },
        {
          value: "csv",
          label: "csv",
        },
        {
          value: "txt",
          label: "txt",
        },
      ],
      //导出表格类型
      exportType: "xlsx",
      downloadLoading: false,
      exportSelect: "xlsx",
      dialogType: 1,
      tabContent:
        "邀请码生成成功！工作人员将在一个工作日内帮您进行任务描述审核。请勿重复提交，请耐心等待。",
      missionContentWarn: "*此处为非必填项，填写任务描述需进行一个工作日的审核",
      HSYSetIdArr: [
        "2088150557908280",
        "2088150558432364",
        "2088150556615435",
        "15386361220094",
        "15332796690024",
        "15089692280009",
        "15218487080046",
      ],
	sys_data:{},//操作数据
    };
  },

  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  watch: {
    "$route.matched": function(n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
    "companyFormData.min_salary"(val) {
      if (val && !this.companyFormData.salary_type) {
        this.$message.error("请先选择结算方式");
        this.companyFormData.min_salary = "";
      }
    },
    "companyFormData.max_salary"(val) {
      if (val && !this.companyFormData.salary_type) {
        this.$message.error("请先选择结算方式");
        this.companyFormData.max_salary = "";
      }
    },
  },
  methods: {
    quickCreate(){
      this.is_quick = true;
    },
    handleQRClose(){
      this.qrVisible = false;
      this.OrImage = "";
      this.alipayOrImage = "";
    },
    showMissionContent(content){
      this.tabType = 2;
      this.tabContent = content;
      this.qrVisible = true;
    },
    // 开启二维码弹框
    showMissionCode(url,data){
      this.OrImage = url;
      this.alipayOrImage = data.alipay_code_url
      this.tabType = 1;
      this.qrVisible = true;
      this.sys_data=data
    },
    getSalaryType(e) {
      return getSalaryTypeText(e);
    },
    // 跳转详情页面
    toView(row) {
      this.$router.push({ name: "privateTask_view", params: row });
    },
    toCustomer(row) {
      console.log();
      this.$router.push({
        path: "/taskCustomer",
        query: { task_id: row.id, task_type: 1 },
      });
    },
    async checkUpload(status, id) {
      var missionStatus;
      if (status == 1) {
        missionStatus = 0;
      }
      if (status == 0) {
        missionStatus = 1;
      }
      let args = {
        status: missionStatus,
        id,
      };
      let res = await this.$api.getMissionSaveStatus(args);
      if (res) {
        this.init();
      }
    },
    changeStatus() {
      this.visible = true;
    },
    selectJob(e){
      let arr = this.jobList.filter(item => e == item.id)[0]
      this.companyFormData = {
        ...this.companyFormData,
        title:arr.recruit_post,
        salary_type: TOG_SALARY_TYPE_VALUE_MAP[arr.salary_type],
        work_city:[arr.province,arr.city,arr.area],
        // recruit_type_id: arr.ph_hr_recruit_task_category.map(item=>item.category_type_id)[0],
        min_qualification: '' + arr.minimum_education,
        min_salary: arr.min_salary,
        max_salary: arr.max_salary,
        person_num: arr.worked_num,
        address: arr.address,
        renew_type: arr.renew_type || 1,
      };
    },
    async getQuickRecruitPostList() {
      let res = await this.$api.recruitTaskList({page_size:0,
      current_page:0});
      this.jobList = res.data
    },
    async getDailyTaskIndustryList() {
      let res = await this.$api.getDailyTaskIndustryList();
      this.formList[1].selectOption = gettreeList(
        res,
        "industry_type_name",
        "id"
      );
    },
    async copyTextToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
      } catch (err) {
        console.error("Failed to copy: ", err);
      }
    },
	copyText(text) {
	this.copyTextToClipboard(text);
	this.$message.success("复制成功");
	},
    copyLink() {
      this.copyTextToClipboard(this.qyLinkForm.url);
      this.$message.success("复制成功");
    },
    async event_searchLink() {
      if (!this.qyLinkForm.mobile) {
        this.$message.warning("请输入手机号");
        return false;
      }
      let args = {
        mobile: this.qyLinkForm.mobile,
      };
      let res = await this.$api.getQyLink(args);
      this.qyLinkForm.url = res.url;
      if (!res.url) {
        this.$message.warning("暂无签约链接");
      }
    },
    showQyLink() {
      this.qyLinkForm = {
        mobile: "",
        url: "",
      };
      this.showQyLinkVisible = !this.showQyLinkVisible;
    },
    goPage(e) {
      this.mxPreview(e.sign_url);
    },
    async downFile(pdfUrl, fileName) {
      try {
        const res = await fetch(pdfUrl);
        if (!res.ok) {
          throw new Error(
            `Failed to fetch PDF: ${res.status} ${res.statusText}`
          );
        }
        const blob = await res.blob();
        const url = URL.createObjectURL(blob); // 传入用于创建 URL 的 File 对象、Blob,转换成浏览器可识别的blob格式
        console.log("url---", url); //blob:http://127.0.0.1:5500/f01dc675-8f01-4e47-9313-65b96321884f
        // 创建a标签，绑定href、download属性，添加在body，触发click事件
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName || "downloaded.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 移除元素
        URL.revokeObjectURL(url); // 当不再需要这些 URL 对象时,通过它释放掉
      } catch (error) {
        console.log(error);
        this.$message.error("提示：" + fileName + "下载文件异常");
      }
    },
    //导出协议
    handleDownload_sign() {
      if (!this.is_E_sign) {
        this.$message.warning("提示：仅E签宝类型支持批量导出");
        return;
      }
      this.sign_downloadLoading = true;
      let i = 0;
      let timer = setInterval(() => {
        if (i > this.companyList.length - 1) {
          this.sign_downloadLoading = false;
          clearInterval(timer);
          return;
        }
        this.downFile(this.companyList[i].sign_url, this.companyList[i].id);
        i++;
      }, 900);
      //console.log(this.companyList,this.$refs.ref_sign.exportPDF())
    },
    //查看协议
    async showXY(e) {
      let surl = "";
      if (e.row.sign_detail.length == 1) {
        surl = e.row.sign_detail[0].sign_url;
      } else if (e.row.sign_detail.length == 0) {
        surl = e.row.sign_url;
      } else {
        this.dialogPdfArr = e.row.sign_detail;
        this.dialogMultPdf = !this.dialogMultPdf;
        return false;
      }

      if (e.row.sign_status == 2) {
        let { id } = e.row;
        let param = {};
        param.id = id;
        console.log(param, "结果");
        let result = await this.$api.getQZinfo(param);
        console.log(result);
        let qzId = result;

        console.log(qzId);

        let str = "/pages/sign/draw";
        if (this.$config.domain.miniappPath) {
          str = this.$config.domain.miniappPath;
        }
        let path = `${str}?id=${qzId}`;
        let args = {
          path: path,
          appId: this.mxDomain.appId,
          id: id, //11/18传入
        };
        let res = await this.$api.createQrcode(args);
        if (res) {
          this.OrImage_qz = res;
          this.qzFlag = true;
        }
        return false;
      }
      if (
        e.row.sign_type == "esign" ||
        e.row.sign_type == "receive_api" ||
        (e.row.sign_type == "import" && e.row.sign_url) ||
        (e.row.sign_type == "openapi" && e.row.sign_url)
      ) {
        this.mxPreview(e.row.sign_url);
      } else if (!e.row.sign_url && e.row.contract_url) {
        this.mxPreview(e.row.contract_url);
      } else {
        this.htmlToPdf(
          e.row.category_name,
          e.row.channel_name,
          e.row.company_name,
          e.row.created_at,
          surl,
          e.row.sign_type,
          e.row.fullname,
          e.row.id_number,
          e.row.channel_taxpayer,
          e.row.id
        );
      }
    },
    changeExportOption(e) {
      this.exportType = e;
    },
    async handleDownload() {
      this.downloadLoading = true;
      let list = await this.init("export");
      import("@/excel/Export2Excel").then((excel) => {
        let sHeader = this.columns.map(item => item.title);
        sHeader.splice(this.columns.length,0,'薪资水平','任务发布时间','审核状态','状态')
        const data = this.formatJson(list);
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `任务列表${time}`;
        excel.export_json_to_excel({
          header: sHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.exportType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(jsonData) {
      return jsonData.map(v =>{
        let tempArr = []
        this.columns.map((item,index)=>{
          tempArr.push(v[item.value])
          if(this.columns.length-1 == index){
            tempArr.splice(this.columns.length,0,this.getSalaryType(v),v.created_at,v.examine_status==1?'审核成功':v.examine_status==2?'审核失败':'审核中',v.status==1?'开启':'关闭')

          }
        })
        return tempArr
      })
    },
    //获取支持批量人才状态
    async isImport() {
      let args = {
        companyId: this.$route.params.company_id,
      };
      let result = await this.$api.isImport(args);
      if (result) {
        this.is_import = result.is_import;
        console.log("this.is_import", this.is_import);
        this.is_show_djg = result.is_show_djg;
        if (this.is_show_djg == 1) {
          let columns = this.columns;
          columns.splice(4, 0, {
            title: "董监高人群",
            value: "is_show_djg",
            header_align: "center",
            align: "center",
          });
          this.columns = columns;
        }
      }
    },
    //关闭二维码弹窗
    closeQRDialog() {
      this.outerVisible = false;
      this.innerVisible = false;

      this.companyFormData = {
        category_id: [],
        name: [],
        missionContent: "",
        mission_type:1,
        renew_type: 1,
      };
    },
    htmlToPdf(
      category_name,
      channel_name,
      company_name,
      created_at,
      sign_url,
      sign_type,
      fullname,
      id_number,
      channel_taxpayer,
      id
    ) {
      if (["tomato", "esign"].includes(sign_type)) {
        this.mxPreview(sign_url);
      } else {
        let path = "/customer/exportpdf";
        if (this.HSYSetIdArr.includes(this.mxSettlementId)) {
          path = "/customer/exportpdf-HSY";
        }
        let routeData = this.$router.resolve({
          path,
          query: {
            category_name,
            channel_name,
            company_name,
            created_at,
            sign_url,
            sign_type,
            fullname,
            id_number,
            channel_taxpayer,
            id,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    //复选框选择时间
    handleTaskChange(val) {
      if (val) {
        this.isCheck = false;
        this.categoryList.find((value) => {
          this.companyFormData.name.forEach((item, index) => {
            if (item == value.name) {
              this.companyFormData.name[index] = value.name;
              this.companyFormData.category_id[index] = value.id;
            }
          });
        });
        this.category_Id = this.companyFormData.category_id.join("、");
        this.category_name = this.companyFormData.name.join("、");
        const { company_id, settlement_id } = this.userInfo;
        this.signUrl = encodeURI(
          `/pages/projectsign/projectsign?companyId=${company_id}&settlementId=${settlement_id}&categoryId=${this.category_Id}&categoryName=${this.category_name}&location=${this.mxDomain.location}`
        );
      }
    },
    //获取签约链接
    async cusomerLink(noOpen) {
      this.is_quick = false;
      this.categoryList = await this.$api.getCustomerCategoryList();
      if(noOpen){
        this.outerVisible = true;
      }
    },
    //关闭内层小dialog×
    handleInnerClose() {
      this.innerVisible = false;
      this.OrImage = "";
      this.alipayOrImage = "";
    },
    //关闭外层dialog小×
    handleOuterClose() {
      this.outerVisible = false;
      this.job_id = '';
      this.$refs.refForm.resetFields()
      this.companyFormData = {
        category_id: [],
        name: [],
        missionContent: "",
        mission_type:1,
        renew_type: 1,
      };
    },
    // //取消外层dialog
    // outerClose() {
    //   this.outerVisible = false;
    //   this.companyFormData = {
    //     category_id: [],
    //     name: []
    //   };
    // },
    //取消内层dialog
    innerClose() {
      this.innerVisible = false;
    },
    checkCategory() {
      // 调用组件的数据验证方法
      this.$refs['refForm'].validate((valid) => {
        if (valid) {
          if (!this.validateSalaryRange()) {
            return;
          }
          if(!this.companyFormData.missionContent){
            this.$message.error('请输入任务描述')
            return;
          }
          if (this.companyFormData.category_id != "") {
            this.getQRCode();
          }
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
      
    },
    validateSalaryRange() {
      const { min_salary, max_salary, salary_type } = this.companyFormData || {};
      if (!salary_type) {
        this.$message.error("请先选择结算方式");
        return false;
      }
      if (!max_salary) {
        this.$message.error("请输入最高薪资金额");
        return false;
      }
      if (!min_salary) {
        this.$message.error("请输入最低薪资金额");
        return false;
      }
      const minVal = Number(min_salary);
      const maxVal = Number(max_salary);
      if (Number.isNaN(minVal) || Number.isNaN(maxVal)) {
        this.$message.error("薪资范围需为数字");
        return false;
      }
      if (minVal > maxVal) {
        this.$message.error("最低薪资不能高于最高薪资");
        return false;
      }
      const salaryLimits = {
        1: { min: 80, max: 5000 }, // 日结
        2: { min: 500, max: 20000 }, // 周结
        3: { min: 2000, max: 100000 }, // 月结
        4: { min: 100, max: 20000 }, // 次结
        5: { min: 1000, max: 500000 }, // 完工结
        6: { min: 10, max: 500 }, // 小时结
      };
      const limit = salaryLimits[salary_type];
      if (limit) {
        if (minVal < limit.min) {
          this.$message.error(`最低薪资为${limit.min}元`);
          return false;
        }
        if (maxVal > limit.max) {
          this.$message.error(`超出薪资上限${limit.max}元`);
          return false;
        }
      }
      return true;
    },
    // 创建二维码
    async createQrCode(id) {
      let str = "/pages/projectsign/projectsign";
      if (this.$config.domain.miniappPath) {
        str = this.$config.domain.miniappPath;
      }
      // todo scene_id=1047 用于小程序判断
      let path = `${str}?id=${id}&companyId=${this.mxCompanyId}&settlementId=${this.mxSettlementId}&scene_id=1047`;
      let args = {
        path: path,
        appId: this.mxDomain.appId,
        id: id,
      };
      let res = await this.$api.createQrcode(args);
      if (res) {
        this.OrImage = res;
      }
    },
    async createAlipayQrCode(id) {
      let str = "pages/projectsign/projectsign";
      if (this.$config.domain.miniappPath) {
        str = this.$config.domain.miniappPath;
      }
      console.log(this.mxDomain, "this.mxDomain");
      let path = `${str}?id=${id}&companyId=${this.mxCompanyId}&settlementId=${this.mxSettlementId}&scene_id=1047`;
      let args = {
        path: path,
        query_param: `id=${id}&companyId=${this.mxCompanyId}&settlementId=${this.mxSettlementId}&scene_id=1047`,
        describe: "扫描此二维码",
        appId: this.mxDomain.alipayAppId,
        id: id,
      };
      let res = await this.$api.createQrcode(args);
      if (res) {
        this.alipayOrImage = res;
      }
    },
    async getQRCode() {
      let nameList = [],
        names,
        remark,
        name;
      this.companyFormData.name.forEach((item) => {
        nameList.push(item.substring(0, item.length - 2));
      });
      names = nameList.join("、");
      name = `${names}`;
      remark = `因委托方业务发展，现需要若干有相关服务经验或能力的自由职业者提供${this.companyFormData.name.join(
        "、"
      )}，具体要求和费用由委托方公布。`;
      let args = {
        name,
        remark,
        category_id: this.companyFormData.category_id.join("、"),
        category_name: this.companyFormData.name.join("、"),
        mission_content: this.companyFormData.missionContent ?? "",
        province: this.companyFormData.work_city[0],
        city: this.companyFormData.work_city[1],
        area: this.companyFormData.work_city[2],
        salary_type: this.companyFormData.salary_type,
        min_salary: this.companyFormData.min_salary,
        max_salary: this.companyFormData.max_salary,
        min_qualification: this.companyFormData.min_qualification,
        address: this.companyFormData.address,
        recruit_type_id: this.companyFormData.recruit_type_id[this.companyFormData.recruit_type_id.length-1],
        title: this.companyFormData.title,
        person_num: this.companyFormData.person_num,
        mission_type: this.companyFormData.mission_type,
        renew_type: this.companyFormData.renew_type || 1,
      };
      let res = await this.$api.getQRCode(args);
      if (res) {
        this.innerVisible = true;
        // if (this.companyFormData.missionContent == "") {
          this.dialogType = 1;
        // } else {
        //   this.dialogType = 2;
        // }
        this.createQrCode(res);
        if (this.mxDomain.appId == "1004" || this.mxDomain.appId == "1001") {
          this.createAlipayQrCode(res);
        }
        this.init("search");
      }
    },

    toPersonnellistExamine(row){
      this.$router.push({
        path: "/privateTask/personnelList",
        query: { id: row.id, task_type: 1 },
      });
    },
    // 搜索
    searchButton() {
      this.is_E_sign = this.searchCondition.sign_type === "esign";
      this.init("search");
    },
    //导入跳转
    importExcel() {
      this.$router.push({ path: "customer/import" });
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
    // 响应添加按钮
    async addButton() {
      // this.$router.push(this.$route.path+'/create')
    },
    // 响应详情按钮
    async viewButton(id) {
      console.log(id);
      this.$router.push(this.$route.path + "/" + id + "/view");
    },
    // 响应编辑按钮
    async editButton(id) {
      console.log(id);
      // this.$router.push(this.$route.path+'/'+id+'/edit')
    },
    // 相应删除按钮
    async deleteButton(id) {
      console.log(id);
      let info = await this.$api.deleteCustomer(id);
      if (info == "ok") {
        this.$nextTick(() => {
          this.init("del");
        });
      } else {
        this.$message.error(info);
      }
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value;
    },
    // 初始化列表
    async init(type) {
      if (type) {
        this.mxResetPage();
      }
      this.loadingStaus = true;
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type == "search") {
        pagingInfo.current_page = 1;
      }
      if (type == "export") {
        pagingInfo.page_size = 50000;
      } else {
        this.loadingStaus = true;
      }
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, pagingInfo);

      let { list, pages } = await this.$api.getMissionList(searchCondition);
      // 对身份证进行处理
      list.map((item) => {
        item.is_show_djg = "否";
        item.all_address += item.address
      });

      if (type == "export") {
        this.loadingStaus = false;
        return list;
      } else {
        this.companyList = [];

        this.$nextTick(() => {
          this.companyList = list;
        });
        this.pagingData.total = pages.total;
        this.offset = pages.offset;
        this.loadingStaus = false;
      }
    },

    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.title) {
        condition.title = this.searchCondition.title;
      }
      if (this.searchCondition.category_id) {
        condition.category_id = this.searchCondition.category_id;
      }
      if (this.searchCondition.recruit_type_id) {
        condition.recruit_type_id = this.searchCondition.recruit_type_id[this.searchCondition.recruit_type_id.length-1];
      }
      if (this.searchCondition.time_value) {
        condition.time = {};
        condition.time.start_time = this.searchCondition.time_value[0];
        condition.time.end_time = this.searchCondition.time_value[1];
      }
      return condition;
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.dialogData.loading_text = "正在提交中……";
      this.dialogData.loading = true;
      this.formData.company_id = this.currentCompanyId;
      let id = await this.$api.saveCompanyAttachment(this.formData);
      this.$nextTick(() => {
        this.dialogClose();
      });
      this.$nextTick(() => {
        if (id) {
          this.initCompanyAttachmentList();
        }
      });
      this.$nextTick(() => {
        this.$message.success("保存成功!");
      });
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs["companyAttacmentForm"].validate((valid) => {
        if (valid) {
          this.formSubmit();
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false;
      this.dialogData.loading = true;
      this.formData = {};
      this.attachmentUploadFileList = [];
    },
    // 响应添加附件按钮
    async addAttachment() {
      this.dialogData.visible = true;
      this.dialogData.loading = false;
      this.dialogData.title = "添加附件";
    },
    // 相应删除文章附件按钮
    async deleteCompanyAttachmentButton(id) {
      let info = await this.$api.deleteCompanyAttachment(id);
      if (info == "ok") {
        this.$nextTick(() => {
          this.initCompanyAttachmentList();
        });
      } else {
        this.$message.error(info);
      }
    },
    keyupSubmit() {
      document.onkeydown = (e) => {
        console.log(e);
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.searchButton();
        }
      };
    },
  },
  created() {
    // let { company_id, settlement_id } = this.userInfo
    this.keyupSubmit();
  },
  mounted() {
    this.init();
    this.cusomerLink(false)
    this.getDailyTaskIndustryList();
    this.getQuickRecruitPostList();
    // this.isImport();
    const { ename } = store.state.domainInfo;
    if (ename == "khlyuecai") {
      this.showLinkBtn = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.task-description-label{
  &:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }
}
 /deep/ .create-task .el-dialog__body{
  padding: 14px 24px 30px;
  .el-select,.el-input,.el-cascader{
    width: 220px;
  }
  .el-input.salary-input{
    width: 100%;
  }
 }
 .quick-create-btn{
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-start;
}
.qyLinkArea {
  display: flex;
  flex-direction: row;
  .linkurl {
    color: #55aaff;
    &-nodata {
      color: #999498;
    }
  }
}
.searchBtnQYLink {
  margin-left: 20px;
}
.item-mobile {
  width: 240px;
}
.mainPDF {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.mainPDF label {
  margin-bottom: 10px;
}

/deep/ .el-checkbox-group label {
  width: 180px;
}

/deep/ .el-checkbox-group label:first-child {
  margin-left: 10px;
}

/deep/ .el-checkbox + .el-checkbox{
  margin-bottom: 8px;

}

/deep/ .el-checkbox-group {
  // width: 660px
}

.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.item-name {
  width: 130px;
}

.table-header-gai {
  display: flex;
  gap: 10px;
  height: 35px;
  margin-bottom: 10px;
}

.table-header {
  margin-bottom: 12px;
}

.el-popover .el-checkbox-group .el-checkbox {
  margin-left: 0px;
  margin-right: 12px;
}

.returnBtn {
  position: relative;
  top: 10px;
  float: right;
}

.table-right {
  float: right;
}

.submitBtn {
  float: right;
  margin-top: 20px;
}

.link-url {
  color: #fff;
  text-decoration: none;
}

.cusomer-link-gai {
  font-size: 15px;
  width: 160px;
}

.cusomer-link-search {
  font-size: 15px;
  width: 160px;
}

.cusomer-link {
  position: absolute;
  top: 0;
  right: 0;
}

.total-num {
  float: right;
  margin-top: 10px;
  margin-right: 20px;
  // position: absolute;
  // top: 0
  // right: 0
  // line-height: 40px
  // padding-right: 20px
}

.span-num {
  color: #f00;
}

.selectWord {
  width: 150px;
}

.link-title {
  text-align: center;
  padding-bottom: 10px;
  color: red;
}

.people-btn-wrapper {
  margin-top: 20px;
}

.dialog-title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: -20px;
}

.title-text {
  font-size: 20px;
  margin-left: 10px;
}

.center-box {
  display: flex;
  justify-content: center;
  align-item: center;
  padding: 30px 0;
  &.code-text-box{
	flex-direction: column;
	align-items: center;
	justify-content: center;
	align-content: center;
	gap: 30px;
	.code-text-con{
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 30px;
		.code-text{
			display: flex;
			align-items: center;
			justify-content: center;
		}
		
	}
  }
}

.code {
  text-align: center;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: center;
  height: 200px;
  overflow: hidden;
  &.alipay-code {
    margin-left: 30px;
    position: relative;
    .QR-code {
      position: relative;
      top: -30px;
      width: 220px;
      height: 220px;
    }
    .tips {
      position: absolute;
      bottom: 0;
    }
  }
  .tips {
    margin-top: 10px;
    font-size: 14px;
    color: #333;
  }
}

.QR-code {
  width: 150px;
  height: 150px;
}

.main-page-content {
  position: relative;
}

.select-box {
  width: 100px;
}

.text-center{
  text-align: center;
}
.el-icon-warning{
  margin: 5px 0 0 4px;
  color: #409EFF;
  font-size: 18px;
}
</style>
